// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"b98d146f","201":"341d6e11","354":"6f8e2d94","365":"784aed30","395":"cc471e45","574":"e0195647","641":"6fb729e5","861":"78614f38","935":"8fc95d71"}[chunkId] + ".chunk.js";
};